import React from "react"
import { Grid, Typography } from "@material-ui/core"
import { Loading, Notification, PopConfirm } from "@/components"
import ContactsFiltersSkeleton from "@/skeletons/Admin/ContactsFiltersSkeleton"
import ContactsFiltersListItem from "@/pages/Admin/ClientCatalog/ClientManageFilters/ContactsFilters/components/ContactsFiltersListItem"
import { BaseContactsFiltersType } from "@/protocols/ClientCatalogFilterProtocol"
import { useGlobalStateStore } from "@/store/GlobalState"
import ErrorHandlerService from "@/services/ErrorHandler"
import { ErrorType } from "@/hooks/useValidation"
import FilterService from "@/services/FilterService"

type ContactFiltersListProps = {
	handleUseFilters: (filter?: BaseContactsFiltersType) => void
	handleOpenEditFilterDialog: (filter?: BaseContactsFiltersType) => void
	setFilters: (filters: BaseContactsFiltersType[]) => void
	filters?: BaseContactsFiltersType[]
	loading: boolean
}

const ContactFiltersList: React.FC<ContactFiltersListProps> = (props) => {
	const { filters, loading, handleUseFilters, handleOpenEditFilterDialog, setFilters } = props
	const globalStateStore = useGlobalStateStore()
	const inboxChannelId = globalStateStore.currentChannel?.id

	const handleDeleteContactFilter = async (filterId?: number) => {
		PopConfirm.open({
			onConfirm: async () => {
				try {
					const updatedFilters = filters?.filter(filter => filter.id !== filterId) || []

					setFilters(updatedFilters)

					await FilterService.delete(filterId, inboxChannelId)
					Notification.success({ message: "Filtro excluído com sucesso!" })
				} catch (error) {
					Notification.error({ message: "Houve um erro ao excluir o filtro" })
					ErrorHandlerService.handle(error as ErrorType)
				}
			},
			title: "Excluir Filtro",
			confirmButtonText: "EXCLUIR"
		})
	}

	return (
		<Grid container spacing={2} direction="column">
			<Grid item>
				<Typography variant="h4">FILTROS SALVOS:</Typography>
			</Grid>

			<Grid item>
				<Loading loading={loading} customLoadingElement={<ContactsFiltersSkeleton />}>
					<Grid style={{ height: 400, overflowY: "auto", overflowX: "hidden" }}>
						<Grid container direction="column" style={{ padding: "5px 10px 5px 2px" }} spacing={1}>
							{filters?.length ? filters.map(filter => (
								<ContactsFiltersListItem
									key={filter.id}
									filter={filter}
									handleUseFilters={handleUseFilters}
									handleDeleteContactFilter={handleDeleteContactFilter}
									handleOpenEditContactFilter={handleOpenEditFilterDialog}
								/>
							)) : (
								<Grid item>
									<Typography>Não há filtros salvos</Typography>
								</Grid>
							)}
						</Grid>
					</Grid>
				</Loading>
			</Grid>
		</Grid>
	)
}

export default ContactFiltersList
